import { UserLocationContext } from '@honda-canada/user-location';
import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setShouldRenderProvinceBanner } from '../../../core/reducers/ui';
const useProvinceBannerVisibility = () => {
    const dispatch = useDispatch();
    const { addressSelectedByUser } = useContext(UserLocationContext);
    useEffect(() => {
        dispatch(setShouldRenderProvinceBanner(!addressSelectedByUser));
    }, [dispatch, addressSelectedByUser]);
};
export default useProvinceBannerVisibility;
